import { render, staticRenderFns } from "./ecLogo.vue?vue&type=template&id=6c347029&lang=pug"
import script from "./ecLogo.vue?vue&type=script&lang=ts"
export * from "./ecLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports